export class TypeTravaux {

	public execution: string;

	public conceptionRealisation: string;

	constructor() { 
		 		this.execution = '';
		this.conceptionRealisation = '';
 
	}
}
